import { ContentButton } from './content/button';
import { ContentIntro } from './content/intro';
import { File } from './file';

/**
 * Model definition for app-feature-preview
 */
export interface AppFeaturePreview {
  __contentType: 'app-feature-preview';
  id: string;
  name?: string;
  intro?: ContentIntro;
  media?: File;
  appStoreUrl?: string;
  googlePlayUrl?: string;
  cta?: ContentButton;
  trustElements?: Array<File>;
}

export function isAppFeaturePreview(obj: { __contentType?: string }): obj is AppFeaturePreview {
  return obj.__contentType === 'app-feature-preview';
}
